import { Action } from '@ngrx/store';
import { Commerce } from 'src/app/models/commerce.model';


export const SET_COMMERCE = '[Commerce models] Set Commerce';
export const UNSET_COMMERCE = '[Commerce models] Unset Commerce';


export class SetCommerceActions implements Action {
    readonly type = SET_COMMERCE;

    constructor(public commerce: Commerce) { }
}

export class UnsetCommerceAction implements Action {
    readonly type = UNSET_COMMERCE;
}


export type acciones = SetCommerceActions | UnsetCommerceAction;
